<template>
  <div id="view-todo">
    <h1>Todo Edit</h1>
    <b-form>
      <h3>Category</h3>
      <b-form-select v-model="form.ctg" :options="ctgs" class="mb-3" /><br/>
      <h3>Title</h3>
      <b-form-input type="text" v-model="form.title" placeholder="Enter your name"></b-form-input><br/>
      <h3>Content</h3>
      <b-form-textarea id="textarea1"
                          v-model="form.content"
                          placeholder="Enter something"
                          :rows="3"
                          :max-rows="6">
      </b-form-textarea><br/>
      <h3>DeadLine</h3>
      <b-form-input v-model="form.deadline" type="date"></b-form-input><br />
     </b-form>
     <div class="btns">
         <b-button variant="success" v-on:click="onSubmit">수정완료</b-button>
         <router-link v-bind:to="{name:'Todoview', params: {todo_id: this.$route.params.todo_id}}">
           <b-button>취소하기</b-button>
         </router-link>
     </div>
     <modal v-if="showModal" @close="showModal = false">
       <h3 slot="header">경고</h3>
       <span slot="footer" @click="showModal = false">할 일을 입력하세요.
         <i class="closeModalBtn fas fa-times" aria-hidden="true"></i>
       </span>
     </modal>
  </div>
</template>

<script>
import  { dbRef } from '../store/db.js';
import Modal from './common/Modal.vue'

export default {
  data(){
    return{
      form:{
        id:'',
        ctg:'',
        title:'',
        content:'',
        deadline:''
      },
      showModal: false
    }
  },
  methods:{
    onSubmit(){
      if (this.form.title !== "" && this.form.ctg !== "" && this.form.content !=="" && this.form.date !=="") {
        dbRef.where('id', '==', this.$route.params.todo_id).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            doc.ref.update({
              ctg: this.form.ctg,
              title: this.form.title,
              content: this.form.content,
              deadline: this.form.deadline
            })
            .then(() => {
              this.$router.push({name: 'Todoview', params: {todo_id: this.form.id}})
            })
          })
        })
      } else {
        this.showModal = !this.showModal;
      }
    }
  },
  created(){
      this.$store.dispatch('getCtgs');
      dbRef.where('id', '==', this.$route.params.todo_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.form.id = doc.data().id
          this.form.ctg = doc.data().ctg
          this.form.title = doc.data().title
          this.form.content = doc.data().content
          this.form.deadline = doc.data().deadline
        })
      })
  },
  computed: {
    ctgs(){
      return this.$store.getters.getCtgs;
    }
  },
  components: {
    Modal: Modal
  }
}
</script>

<style scoped>
#view-todo{
  margin-left: 10%;
  margin-right: 10%;
}
h3{
  text-align: left;
  margin-bottom: 1%;
}
.btns{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/TodoEdit.vue